import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useWindowSize from "../../../useWindowSize";
import {
  fetchData,
  Get_DRD_PDF_Links,
  Get_JNTUA_PDF_Links,
  Get_SR_PDF_Links,
  imageBaseURL,
} from "../../../utils/fetchData";
import { JNTUK_API_Urls } from "../../../utils/api.config";

export const DAPMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  const [bTech, setBTech] = useState([]);
  const [bPharmacyR, setBPharmacyR] = useState([]);
  const [bPharmacyC, setBPharmacyC] = useState([]);
  const [mTech, setMTech] = useState([]);
  const [mPharmacy, setMPharmacy] = useState([]);
  const [MBAR, setMBAR] = useState([]);
  const [MBAC, setMBAC] = useState([]);
  const [MCAR, setMCAR] = useState([]);
  const [MCAC, setMCAC] = useState([]);
  const [PharmR, setPharmR] = useState([]);
  const [PharmC, setPharmC] = useState([]);
  const [MSC, setMSC] = useState([]);
  const [Accreditations, setAccreditations] = useState([]);
  useEffect(() => {
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=B.Tech&pagination[limit]=1000`,
      setBTech
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=B.Pharmacy&pagination[limit]=1000`,
      setBPharmacyR
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Course Structure&filters[Course][$contains]=B.Pharmacy&pagination[limit]=1000`,
      setBPharmacyC
    );

    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=M.Tech&pagination[limit]=1000`,
      setMTech
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=M.Pharmacy&pagination[limit]=1000`,
      setMPharmacy
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=MBA&pagination[limit]=1000`,
      setMBAR
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Course Structure&filters[Course][$contains]=MBA&pagination[limit]=1000`,
      setMBAC
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=MCA&pagination[limit]=1000`,
      setMCAR
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Course Structure&filters[Course][$contains]=MCA&pagination[limit]=1000`,
      setMCAC
    );

    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=Pharm.D, Pharm.D(PB)&pagination[limit]=1000`,
      setPharmR
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Course Structure&filters[Course][$contains]=Pharm.D, Pharm.D(PB)&pagination[limit]=1000`,
      setPharmC
    );
    fetchData(
      JNTUK_API_Urls["DAP-Curriculum"] +
      `&filters[Type][$contains]=Regulations&filters[Course][$contains]=M.Sc&pagination[limit]=1000`,
      setMSC
    );

    // Fetch Accreditations
    fetchData(
      JNTUK_API_Urls["OTPRI-Accreditations"] + `&pagination[limit]=1000`,
      setAccreditations
    );
  }, []);
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/dap"}>Home</Link>
            </li>
            <li>
              <Link to={"/dap/about-directorate"}>About</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Courses Offered</Link>
              <ul>
                <li>
                  <Link to={"/dap/ug-programmes"}>UG Programmes</Link>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">PG Programmes</Link>
                  <ul>
                    <li>
                      <Link to={"/dap/regular-courses"}>Regular Courses</Link>
                    </li>
                    <li>
                      <Link to={"/dap/part-time"}>Part Time</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to={"/dap/integrated-dual-degree-programmes"}>
                    Integrated Dual Degree
                  </Link>
                </li>
                <li>
                  <Link to={"/dap/mous-list"}>MoU's List</Link>
                </li>
                <li>
                  <Link to={"/dap/research-programmes"}>
                    Research Programmes
                  </Link>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Curriculum</Link>
              <ul>
                <li className="hasSubmenu">
                  <Link to={"#"}>UG</Link>
                  <ul>
                    <li className="hasSubmenu">
                      <Link to={"#"}>B.Tech</Link>
                      <ul>
                        <li>
                          <li className="hasSubmenu">
                            <Link to="#">Regulations</Link>
                            <ul>
                              {bTech?.data?.map((obj, index) => (
                                <li>
                                  <a
                                    href={
                                      imageBaseURL +
                                      obj?.attributes?.File?.data?.attributes
                                        ?.url
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {obj?.attributes?.For}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </li>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            <li>
                              <Link to={`/dap/curriculum/R15/B.Tech`}>R15</Link>
                            </li>
                            <li>
                              <Link to={`/dap/curriculum/R19/B.Tech`}>R19</Link>
                            </li>
                            <li>
                              <Link to={`/dap/curriculum/R20/B.Tech`}>R20</Link>
                            </li>
                            <li>
                              <Link to={`/dap/curriculum/R23/B.Tech`}>R23</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="hasSubmenu">
                      <Link to={"#"}>B.Pharmacy</Link>
                      <ul>
                        <li className="hasSubmenu">
                          <Link to="#">Regulations</Link>
                          <ul>
                            {bPharmacyR?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            {bPharmacyC?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li className="hasSubmenu">
                  <Link to={"#"}>PG</Link>
                  <ul>
                    <li className="hasSubmenu">
                      <Link to={"#"}>M.Tech</Link>
                      <ul>
                        <li className="hasSubmenu">
                          <Link to="#">Regulations</Link>
                          <ul>
                            {mTech?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            <li>
                              <Link to={`/dap/curriculum/R17/M.Tech`}>R17</Link>
                            </li>
                            <li>
                              <Link to={`/dap/curriculum/R21/M.Tech`}>R21</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="hasSubmenu">
                      <Link to={"#"}>M.Pharmacy</Link>
                      <ul>
                        <li className="hasSubmenu">
                          <Link to="#">Regulations</Link>
                          <ul>
                            {mPharmacy?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            <li>
                              <Link to={`/dap/curriculum/R17/M.Pharmacy`}>
                                R17
                              </Link>
                            </li>
                            <li>
                              <Link to={`/dap/curriculum/R21/M.Pharmacy`}>
                                R21
                              </Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="hasSubmenu">
                      <Link to={"#"}>MBA</Link>
                      <ul>
                        <li className="hasSubmenu">
                          <Link to="#">Regulations</Link>
                          <ul>
                            {MBAR?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            {MBAC?.data?.map(
                              (obj, index) =>
                                obj?.attributes?.For !== "R21" && (
                                  <li>
                                    <a
                                      href={
                                        imageBaseURL +
                                        obj?.attributes?.File?.data?.attributes
                                          ?.url
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {obj?.attributes?.For}
                                    </a>
                                  </li>
                                )
                            )}
                            <li>
                              <Link to={`/dap/curriculum/R21/MBA`}>R21</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="hasSubmenu">
                      <Link to={"#"}>MCA</Link>
                      <ul>
                        <li className="hasSubmenu">
                          <Link to="#">Regulations</Link>
                          <ul>
                            {MCAR?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            {MCAC?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="hasSubmenu">
                      <Link to={"#"}>Pharm.D, Pharm.D(PB)</Link>
                      <ul>
                        <li className="hasSubmenu">
                          <Link to="#">Regulations</Link>
                          <ul>
                            {PharmR?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            {PharmC?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="hasSubmenu">
                      <Link to={"#"}>M.Sc</Link>
                      <ul>
                        <li className="hasSubmenu">
                          <Link to="#">Regulations</Link>
                          <ul>
                            {MSC?.data?.map((obj, index) => (
                              <li>
                                <a
                                  href={
                                    imageBaseURL +
                                    obj?.attributes?.File?.data?.attributes?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {obj?.attributes?.For}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="hasSubmenu">
                          <Link to="#">Course Structure & Syllabi</Link>
                          <ul>
                            <li>
                              <Link to={`/dap/curriculum/R20/M.Sc`}>R20</Link>
                            </li>
                            <li>
                              <Link to={`/dap/curriculum/R21/M.Sc`}>R21</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">News Bulletin</Link>
              <ul>
                <li>
                  <Link to={"/dap/category/circulars"}>Circulars</Link>
                </li>
                <li>
                  <Link to={"/dap/category/uncategorized"}>Uncategorized</Link>
                </li>
                <li>
                  <Link to={"/dap/downloads"}>Downloads</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={"/dap/newsletter"}>Newsletter</Link>
            </li>
            <li>
              <Link to={"/dap/academic-senate"}>Academic Senate</Link>
            </li>
            <li>
              <Link to={"/dap/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/dap/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const DAMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/da"}>Home</Link>
            </li>
            <li>
              <Link to={"/da/about-directorate"}>About</Link>
            </li>
            <li>
              <Link to={"/category/University-Admissions"}>Notifications</Link>
            </li>
            <li>
              <Link to={"/da/newsletter"}>Newsletter</Link>
            </li>
            <li>
              <Link to={"/da/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/da/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
export const DEMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/de"}>Home</Link>
            </li>
            <li>
              <Link to={"/de/about-directorate"}>About</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Officers</Link>
              <ul>
                <li>
                  <Link to={"/profile/controller-of-examinations-pg"}>
                    Controller of Examinations
                  </Link>
                </li>
                <li>
                  <Link to={"/addl-controller-of-examinations"}>
                    Addl Controller of Examinations
                  </Link>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Downloads</Link>
              <ul>
                <li>
                  <Link to={"/category/University-Examinations"}>
                    DE Notifications
                  </Link>
                </li>
                <li>
                  <Link to={"/examination-branch-application-forms"}>
                    Application Forms
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <a
                href={"https://jntuaresults.ac.in/"}
                target="_blank"
                rel="noreferrer"
              >
                Results
              </a>
            </li>
            <li>
              <Link to={"/de/newsletter"}>Newsletter</Link>
            </li>
            <li>
              <Link to={"/de/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/de/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const DRDMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  const [DRD_PDF_Links, setDRDPdfLinks] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const data = await Get_DRD_PDF_Links();
      setDRDPdfLinks(data);
    };

    fetchData();
  }, []);
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/drd"}>Home</Link>
            </li>
            <li>
              <Link to={"/drd/about-directorate"}>About</Link>
            </li>

            <li>
              <Link to={"/drd/ph-d-scholars-admitted"}>
                Ph.D. Scholars Admitted
              </Link>
            </li>
            <li className="hasSubmenu">
              <a href="javascript:void(0)">Syllabus</a>
              <ul>
                <li className="hasSubmenu">
                  <a href="javascript:void(0)">R21</a>
                  <ul>
                    <li>
                      <a
                        href={DRD_PDF_Links?.Research_and_Publication_Ethics}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Reseach & Publication Ethics
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="hasSubmenu">
                  <a href="javascript:void(0)">R18</a>
                  <ul>
                    <li>
                      <a
                        href={DRD_PDF_Links?.Research_Methodology}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Research Methodology
                      </a>
                    </li>
                    <li>
                      <a
                        href={DRD_PDF_Links?.IPR}
                        target="_blank"
                        rel="noreferrer"
                      >
                        IPR
                      </a>
                    </li>
                    <li>
                      <Link to={"/drd/part-1-part-2-subjects"}>
                        Part 1 and Part 2 subjects
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li className="hasSubmenu">
              <a href="javascript:void(0)">Research Centers</a>
              <ul>
                <li>
                  <a
                    href={DRD_PDF_Links?.Guidlines}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Guidelines
                  </a>
                </li>
                <li>
                  <a
                    href={DRD_PDF_Links?.Application_For_Research_Center}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Application for Research center
                  </a>
                </li>
                <li className="hasSubmenu">
                  <a href="javascript:void(0)">List of Research centers</a>
                  <ul>
                    <li className="hasSubmenu">
                      <a href="javascript:void(0)">Pharmacy</a>
                      <ul>
                        <li className="hasSubmenu">
                          <a href="javascript:void(0)">Engineering</a>
                          <ul>
                            <li>
                              <a
                                href={DRD_PDF_Links?.Constituent_Units}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Constituent Units
                              </a>
                            </li>
                            <li>
                              <a
                                href={DRD_PDF_Links?.Affilated_College}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Affilated College
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li className="ms-lg-auto hasSubmenu">
              <a href="javascript:void(0)">More</a>
              <ul>
                <li>
                  <Link to={"/category/Research-&-Development"}>
                    Notifications
                  </Link>
                </li>
                <li>
                  <Link to={"/drd/regulations"}>Regulations</Link>
                </li>
                <li>
                  <Link to={"/drd/downloads"}>Downloads</Link>
                </li>
                <li>
                  <Link to={"/drd/ph-d-vacancies"}>Ph.D. Vacancies</Link>
                </li>
                <li>
                  <Link to={"/drd/newsletter"}>Newsletter</Link>
                </li>
                <li>
                  <Link to={"/drd/gallery"}>Gallery</Link>
                </li>
                <li>
                  <Link to={"/drd/contact-us"}>Contact Us</Link>
                </li>
              </ul>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const DIRPMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/dirp"}>Home</Link>
            </li>
            <li>
              <Link to={"/dirp/about-directorate"}>About Directorate</Link>
            </li>
            <li>
              <Link to={"/profile/dirp-coordinator"}>Coordinator</Link>
            </li>
            <li>
              <Link to={"/category/Industrial-Relations-&-Placements"}>
                Notifications
              </Link>
            </li>
            <li>
              <Link to={"/dirp/placements"}>Placements</Link>
            </li>
            <li>
              <Link to={"/dirp/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/dirp/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
export const DICSMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  const [JNTUA_PDF_Links, setJNTUAPdfLinks] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const data = await Get_JNTUA_PDF_Links();
      setJNTUAPdfLinks(data);
    };

    fetchData();
  }, []);
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/dics"}>Home</Link>
            </li>
            <li>
              <Link to={"/dics/about-directorate"}>About Directorate</Link>
            </li>
            <li>
              <Link to={"/category/Industrial-Consultancy-Services"}>
                ICS Notifications
              </Link>
            </li>
            <li>
              <a
                href={JNTUA_PDF_Links?.DICS_Infrastructure_Resources}
                target="_blank"
                rel="noreferrer"
              >
                Infrastructure Resources
              </a>
            </li>
            <li>
              <Link to={"/dics/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/dics/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const DFAAMMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  const [JNTUA_PDF_Links, setJNTUAPdfLinks] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const data = await Get_JNTUA_PDF_Links();
      setJNTUAPdfLinks(data);
    };
    fetchData();
  }, []);
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/dfaam"}>Home</Link>
            </li>
            <li>
              <Link to={"/dfaam/about-directorate"}>About</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Foreign Affairs</Link>
              <ul>
                <li>
                  <Link to={"/dfaam/mous"}>MOU's/Collaborations</Link>
                </li>
                <li>
                  <Link to={"/dfaam/list-of-foreign-students"}>
                    List of Foreign Students
                  </Link>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Alumini Matters</Link>
              <ul>
                <li>
                  <a
                    href={JNTUA_PDF_Links?.Distiguished_Alumni}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Distiguished Alumni
                  </a>
                </li>
                <li>
                  <a
                    href={"https://alumni.jntua.ac.in/register.php"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Registration
                  </a>
                </li>
                <li>
                  <Link to={"/dfaam/sponsored-gold-medals"}>
                    Sponsored Gold Medals/Scholarship/Donations
                  </Link>
                </li>
                <li>
                  <Link to={"/dfaam/emratus"}>Emratus</Link>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">UGC Matters</Link>
              <ul>
                <li>
                  <Link to={"/dfaam/12b-2f-certificates"}>
                    12(B) & 2(F) Certificates
                  </Link>
                </li>
                <li>
                  <Link to={"/dfaam/ugc-xi-plan"}>UGC XI Plan</Link>
                </li>
                <li>
                  <Link to={"/dfaam/ugc-xii-plan"}>UGC XII Plan Grants</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={"/dfaam/notifications"}>Notifications</Link>
            </li>
            <li>
              <a
                href={JNTUA_PDF_Links?.BTH_Students_List}
                target="_blank"
                rel="noreferrer"
              >
                BTH Students List
              </a>
            </li>
            <li>
              <Link to={"/dfaam/newsletter"}>Newsletter</Link>
            </li>
            <li>
              <Link to={"/dfaam/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/dfaam/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const DFDMMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  const [data, setData] = useState([]);
  const [minutes, setMinutes] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [guidelines, setGuidelines] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [JNTUA_PDF_Links, setJNTUAPdfLinks] = useState(null);
  useEffect(() => {
    fetchData(JNTUK_API_Urls["DFD-Committee"], setData);
    fetchData(JNTUK_API_Urls["DFD-SSS-Minutes"], setMinutes);
    fetchData(JNTUK_API_Urls["DFD-Feedback"], setFeedbacks);
    fetchData(JNTUK_API_Urls["DFD-Guidelines"], setGuidelines);
    fetchData(JNTUK_API_Urls["DFD-Certificates"], setCertificates);
    const fetchPdfData = async () => {
      const data = await Get_JNTUA_PDF_Links();
      setJNTUAPdfLinks(data);
    };

    fetchPdfData();
  }, []);
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/diqac"}>Home</Link>
            </li>
            <li className="hasSubmenu">
              <a
                href={JNTUA_PDF_Links?.DIQAC_Committee_File}
                target="_blank"
                rel="noreferrer"
              >
                Committee
              </a>
              <ul>
                {data?.data?.map((obj, index) => (
                  <li>
                    <a
                      href={
                        imageBaseURL +
                        obj?.attributes?.File?.data?.attributes?.url
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {obj?.attributes?.Title}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">SSS/Minutes</Link>
              <ul>
                {minutes?.data?.map((obj, index) => (
                  <li>
                    <a
                      href={
                        imageBaseURL +
                        obj?.attributes?.File?.data[0]?.attributes?.url
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {`${index + 1} ${obj?.attributes?.Title}`}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Feedback</Link>
              <ul>
                {feedbacks?.data?.map((obj, index) => (
                  <li>
                    <a
                      href={
                        imageBaseURL +
                        obj?.attributes?.File?.data?.attributes?.url
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {obj?.attributes?.Title}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
            <li>
              <Link to={"#"}>AQAR</Link>
            </li>
            <li>
              <Link to={"#"}>SSR</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Certificates</Link>
              <ul>
                {certificates?.data?.map((obj, index) => (
                  <li>
                    <a
                      href={
                        imageBaseURL +
                        obj?.attributes?.File?.data?.attributes?.url
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {obj?.attributes?.Title}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Guidelines</Link>
              <ul>
                {guidelines?.data?.map((obj, index) => (
                  <li>
                    <a
                      href={
                        imageBaseURL +
                        obj?.attributes?.File?.data?.attributes?.url
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {obj?.attributes?.Title}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">More</Link>
              <ul>
                <li>
                  <Link to={"#"}>Circulars</Link>
                </li>
                <li>
                  <Link to={"#"}>Activities</Link>
                </li>
                <li>
                  <Link to={"#"}>Latest Information</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={"#"}>News Letter</Link>
            </li>
            <li>
              <Link to={"/diqac/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/diqac/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const DSDCMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/sdc"}>Home</Link>
            </li>
            <li>
              <Link to={"/sdc/about-directorate"}>About</Link>
            </li>
            <li>
              <Link to={"/sdc/people"}>People</Link>
            </li>
            <li>
              <Link to={"/sdc/newsletter"}>Newsletter</Link>
            </li>

            <li>
              <Link to={"/sdc/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/sdc/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const DWECMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/wec"}>Home</Link>
            </li>
            <li>
              <Link to={"/wec/about-directorate"}>About</Link>
            </li>
            <li>
              <Link to={"/wec/internal-compliant-committee"}>
                Internal Compliant Committee
              </Link>
            </li>
            <li>
              <Link to={"/wec/notifications"}>Notifications</Link>
            </li>
            <li>
              <Link to={"/wec/newsletter"}>Newsletter</Link>
            </li>
            <li>
              <Link to={"/wec/programmes"}>Programmes</Link>
            </li>
            <li>
              <Link to={"/wec/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/wec/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SDICMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/sdic"}>Home</Link>
            </li>
            <li>
              <Link to={"/sdic/about-us"}>About Us</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Skill Development</Link>
              <ul>
                <li>
                  <Link to={"/sdic/events"}>Events</Link>
                </li>
                <li>
                  <Link to={"/sdic/company-linkages"}>Company Linkages</Link>
                </li>
                <li>
                  <Link to={"/sdic/dassult-systems"}>Dassult Systems</Link>
                </li>
                <li>
                  <Link to={"/sdic/siemens-centre-of-excellence"}>
                    Siemens Centre of Excellence
                  </Link>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Incubation Centre</Link>
              <ul>
                <li>
                  <Link to={"/sdic/services"}>Services</Link>
                </li>
                <li>
                  <Link to={"/sdic/ic-events"}>Facilities</Link>
                </li>
                <li>
                  <Link to={"/sdic/startups"}>Startups</Link>
                </li>
                <li>
                  <Link to={"/sdic/partners"}>Partners</Link>
                </li>
                <li>
                  <Link to={"/sdic/incubatee"}>Incubatee</Link>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Team</Link>
              <ul>
                <li className="hasSubmenu">
                  <Link to="/sdic/mentors">Mentors</Link>
                  <ul>
                    <li>
                      <Link to={"/sdic/mentors/alumni"}>Alumni</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to={"/sdic/investors"}>Investors</Link>
                </li>
                <li>
                  <Link to={"/sdic/mentors/industry"}>Advisory Board</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={"/sdic/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/sdic/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const NSSMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/nss"}>Home</Link>
            </li>
            <li>
              <Link to={"/nss/about-us"}>About Us</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">About NSS Cell</Link>
              <ul>
                <li>
                  <Link to={"/nss/about-nss-cell/achievements"}>
                    Achievements
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/nss/about-nss-cell/activities-college-wise-2016-17"}
                  >
                    Activities College 2016-17
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/nss/about-nss-cell/activities-college-wise-2017-18"}
                  >
                    Activities College 2017-18
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/nss/about-nss-cell/activities-college-wise-2018-19"}
                  >
                    Activities College 2018-19
                  </Link>
                </li>
                <li>
                  <Link to={"/nss/about-nss-cell/special-camp-2017-18"}>
                    Special Camps 2017-18
                  </Link>
                </li>
                <li>
                  <Link to={"/nss/about-nss-cell/special-camp-2018-19"}>
                    Special Camps 2018-19
                  </Link>
                </li>
                <li>
                  <Link to={"/nss/about-nss-cell/innovative-activities"}>
                    Innovative Activities
                  </Link>
                </li>
                <li>
                  <Link to={"/nss/about-nss-cell/nss-program-officers"}>
                    NSS Program Officers
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={"/category/NSS-Cell"}>Notifications</Link>
            </li>
            <li>
              <Link to={"/nss/nss-units-under-jntua"}>
                NSS Units under JNTUA
              </Link>
            </li>
            <li>
              <Link to={"/nss/downloads"}>Downloads</Link>
            </li>
            <li>
              <Link to={"/nss/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/nss/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SCSTMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/scst"}>Home</Link>
            </li>
            <li>
              <Link to={"/scst/about-us"}>About Us</Link>
            </li>
            <li>
              <Link to={"/scst/downloads"}>Downloads</Link>
            </li>
            <li>
              <Link to={"/scst/others"}>Others</Link>
            </li>
            <li>
              <Link to={"/scst/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/scst/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SPORTSMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/sports"}>Home</Link>
            </li>
            <li>
              <Link to={"/sports/about-us"}>About Us</Link>
            </li>
            <li>
              <Link to={"/sports/downloads"}>Downloads</Link>
            </li>
            <li>
              <Link to={"/sports/others"}>Others</Link>
            </li>
            <li>
              <Link to={"/sports/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/sports/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const ARCMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/arc"}>Home</Link>
            </li>
            <li>
              <Link to={"/arc/about-us"}>About Us</Link>
            </li>
            <li>
              <Link to={"/arc/downloads"}>Downloads</Link>
            </li>
            <li>
              <Link to={"/arc/others"}>Others</Link>
            </li>
            <li>
              <Link to={"/arc/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/arc/contact-us"}>Contact Us</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SRMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  const [SR_PDF_Links, setJNTUAPdfLinks] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const data = await Get_SR_PDF_Links();
      setJNTUAPdfLinks(data);
    };

    fetchData();
  }, []);
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/sr"}>Home</Link>
            </li>
            <li>
              <a
                href={SR_PDF_Links?.About_Directorate}
                target="_blank"
                rel="noreferrer"
              >
                About
              </a>
            </li>
            <li>
              <a
                href={SR_PDF_Links?.Newsletter}
                target="_blank"
                rel="noreferrer"
              >
                Newsletter
              </a>
            </li>
            <li>
              <a
                href={SR_PDF_Links?.Patents_Published}
                target="_blank"
                rel="noreferrer"
              >
                Patents Published/Granted
              </a>
            </li>
            <li>
              <Link to={"/sr/research-seed-grant"}>Research Seed Grant</Link>
            </li>
            <li>
              <a
                href={SR_PDF_Links?.Research_Projects}
                target="_blank"
                rel="noreferrer"
              >
                Research Projects
              </a>
            </li>
            <li>
              <a
                href={SR_PDF_Links?.Research_Facilities}
                target="_blank"
                rel="noreferrer"
              >
                Research Facilities
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const SMSMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/sms"}>Home</Link>
            </li>
            <li>
              <Link to={"/sms/about-us"}>About</Link>
            </li>
            <li>
              <a href="https://heyzine.com/flip-book/219f7d138c.html" target="_blank">JNTUA Digital Diary 2022</a>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Administration</Link>
              <ul>
                <li>
                  <Link to={"/profile/vice-chancellor"}>Vice Chancellor</Link>
                </li>
                <li>
                  <Link to={"/profile/rector"}>Rector</Link>
                </li>
                <li>
                  <Link to={"/profile/registrar"}>Registrar</Link>
                </li>
                <li>
                  <Link to={"/profile/school-of-management-studies"}>Director/Head</Link>
                </li>
                <li>
                  <Link to={"/sms/people-at-helm-of-affairs"}>People at Helm of Affairs</Link>
                </li>
                <li>
                  <Link to={"/sms/props"}>PROPs</Link>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                    target="_blank"
                    rel="noreferrer"
                  >Grievance Redressal Flow Chart</a>
                </li>
              </ul>
            </li>
            <li>
              <Link to={"/sms/aicte-approval-order"}>AICTE Approval Orders</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Academics</Link>
              <ul>
                <li>
                  <Link to={"/sms/faculty"}>Faculty</Link>
                </li>
                <li>
                  <Link to={"/sms/courses-offered"}>Courses Offered</Link>
                </li>
                <li>
                  <Link to={"/sms/syllabus"}>Syllabus</Link>
                </li>
                <li>
                  <Link to={"/sms/guest-lectures"}>Guest Lectures</Link>
                </li>
                <li>
                  <Link to={"/sms/previous-papers"}>Previous Papers</Link>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Master_Time_Table_OF_MBA_I_IV_SEM_2020_21_MODIFIED_FINAL_9f05eee6d4.xlsx"}
                    target="_blank"
                    rel="noreferrer"> Master Time table of MBA 1 & IV SEM 2020-21</a>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Admission</Link>
              <ul>
                <li>
                  <Link to={"/sms/admission"}>Admission</Link>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                    target="_blank"
                    rel="noreferrer">GO AP MBA ADMISSION SEATS 2020-21</a>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                    target="_blank"
                    rel="noreferrer">Admissions Documents to Submit</a>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Students</Link>
              <ul>
                <li>
                  <Link to={"/sms/students"}>Students</Link>
                </li>
                 <li>
                  <Link to={"/sms/jntua-sms-campus-life-photos"}>JNTUA SMS CAMPUS LIFE PHOTOS</Link>
                </li>
                <li>
                  <Link to={"/sms/alumni"}>Alumni</Link>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">Students Club</Link>
                  <ul>
                    <li>
                      <a href={"https://app.gojntua.com/uploads/Marketing_club_e68884ac00.pdf"}
                        target="_blank"
                        rel="noreferrer">Marketing Club</a>
                    </li>
                    <li>
                      <a href={"https://app.gojntua.com/uploads/Finance_club_9ac6dcce6b.pdf"}
                        target="_blank"
                        rel="noreferrer">Finance Club</a>
                    </li>
                    <li>
                      <a href={"https://app.gojntua.com/uploads/Human_Resource_Club_ddb0fd3082.pdf"}
                        target="_blank"
                        rel="noreferrer">Human Resources Club</a>
                    </li>
                    <li>
                      <a href={"https://app.gojntua.com/uploads/Systems_Club_e6f00ac5dc.pdf"}
                        target="_blank"
                        rel="noreferrer">Systems Club</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Student_activities_1910eb1fd9.pdf"}
                    target="_blank"
                    rel="noreferrer">Student Activities</a>
                </li>
              </ul>
            </li>
            <li>
              <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                target="_blank"
                rel="noreferrer">Library</a>
            </li>
            <li>
              <a href="/rti-act" target="_blank">RTI ACT</a>
            </li>
            <li className="hasSubmenu">
              <Link to="#">NIRF</Link>
              <ul>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                    target="_blank"
                    rel="noreferrer"> NIRF 2019</a>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                    target="_blank"
                    rel="noreferrer"> NIRF 2020</a>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                    target="_blank"
                    rel="noreferrer"> NIRF 2021</a>
                </li>
                <li>
                  <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                    target="_blank"
                    rel="noreferrer"> NIRF 2022</a>
                </li>
              </ul>
            </li>
            <li>
              <a href={"https://app.gojntua.com/uploads/Creation_Under_Construction_64d5ad6360.pdf"}
                target="_blank"
                rel="noreferrer">ISO Certificate</a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const OTPRIMenu = () => {
  const { internalMenuOpen, setInternalMenuOpen } = useWindowSize();
  const [Accreditations, setAccreditations] = useState([]);
  const [StudentsAchievements, setStudentsAchievements] = useState([]);
  const [STCell, setSTCell] = useState(null);
  const [WomenEmpowermentCell, setWomenEmpowermentCell] = useState(null);
  const [Committee, setCommittee] = useState(null);
  const [AntiRaggingCell, setAntiRaggingCell] = useState(null);
  const [GrievanceRedressedCommittee, setGrievanceRedressedCommittee] = useState(null);
  const [GenderSensitisation, setGenderSensitisation] = useState(null);
  const [FacultyFoodTechnology, setFacultyFoodTechnology] = useState(null);
  const [CoursesOfferedFT, setCoursesOfferedFT] = useState(null);
  const [AdmissionDetailsFT, setAdmissionDetailsFT] = useState(null);
  const [CareerGuidance, setCareerGuidance] = useState(null);
  const [InternalExamination, setInternalExamination] = useState(null);
  const [ProgramsOrganized, setProgramsOrganized] = useState(null);

  useEffect(() => {
    // Fetch Accreditations
    fetchData(
      JNTUK_API_Urls["OTPRI-Accreditations"] + `&pagination[limit]=1000`,
      setAccreditations
    );

    // Fetch Students Achievements
    fetchData(
      JNTUK_API_Urls["OTPRI-Students-Achievements"] + `&pagination[limit]=1000`,
      setStudentsAchievements
    );

    // Fetch ST Cell
    fetchData(
      JNTUK_API_Urls["OTPRI-ST-Cell"],
      setSTCell
    );

    // Fetch Women Empowerment Cell
    fetchData(
      JNTUK_API_Urls["OTPRI-Women-Empowerment-Cell"],
      setWomenEmpowermentCell
    );

    // Fetch Committee
    fetchData(
      JNTUK_API_Urls["OTPRI-Committee"],
      setCommittee
    );

    // Fetch Anti Ragging Cell
    fetchData(
      JNTUK_API_Urls["OTPRI-Anti-Ragging-Cell"],
      setAntiRaggingCell
    );

    // Fetch Grievance Redressed Committee
    fetchData(
      JNTUK_API_Urls["OTPRI-Grievance-Redressed-Committee"],
      setGrievanceRedressedCommittee
    );

    // Fetch Gender Sensitisation
    fetchData(
      JNTUK_API_Urls["OTPRI-Gender-Sensitisation"],
      setGenderSensitisation
    );

    // Fetch Faculty Food Technology
    fetchData(
      JNTUK_API_Urls["OTPRI-Faculty-Food-Technology"],
      setFacultyFoodTechnology
    );

    // Fetch Courses Offered FT
    fetchData(
      JNTUK_API_Urls["OTPRI-Courses-Offered-FT"],
      setCoursesOfferedFT
    );

    // Fetch Admission Details FT
    fetchData(
      JNTUK_API_Urls["OTPRI-Admission-Details-FT"],
      setAdmissionDetailsFT
    );

    // Fetch Career Guidance
    fetchData(
      JNTUK_API_Urls["OTPRI-Career-Guidance"],
      setCareerGuidance
    );

    // Fetch Internal Examination
    fetchData(
      JNTUK_API_Urls["OTPRI-Internal-Examination"],
      setInternalExamination
    );

    // Fetch Programs Organized
    fetchData(
      JNTUK_API_Urls["OTPRI-Programs-Organized"],
      setProgramsOrganized
    );
  }, []);

  return (
    <div className="department-menu">
      <div className="container">
        <div className="d-xl-none text-white align-items-center py-3 d-flex justify-content-between">
          Menu
          <span
            className="fad fa-list-ul"
            onClick={() => {
              setInternalMenuOpen(!internalMenuOpen);
            }}
          ></span>
        </div>
        {internalMenuOpen && (
          <ul>
            <li>
              <Link to={"/otpri"}>Home</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">About Us</Link>
              <ul>
                <li>
                  <Link to={"/otpri/about-us"}>About College</Link>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">Accreditations</Link>
                  <ul>
                    {Accreditations?.data?.attributes?.links?.map((accreditationGroup) => (
                      <li key={accreditationGroup.id} className="hasSubmenu">
                        <Link to="#">{accreditationGroup.title}</Link>
                        <ul>
                          {accreditationGroup.links?.map((link) => (
                            <li key={link.id}>
                              <a
                                href={imageBaseURL + link.content?.data?.attributes?.url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {link.label}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <Link to={"/otpri/silent-features"}>Silent Features of Institutions</Link>
                </li>
                <li>
                  <Link to={"/otpri/approval"}>Approval</Link>
                </li>
                <li>
                  <Link to={"/otpri/pharmacy-history"}>Pharmacy History & Evolution of Pharmacy</Link>
                </li>
                <li>
                  <Link to={"/university-song"}>JNTU ANTHEM</Link>
                </li>
              </ul>
            </li>

            <li className="hasSubmenu">
              <Link to="#">Academics</Link>
              <ul>
                <li className="hasSubmenu">
                  <Link to="#">Faculty</Link>
                  <ul>
                    <li>
                      <Link to={"/otpri/faculty-of-pharmacy"}>Faculty Pharmacy</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to={"/otpri/courses-offered"}>Courses Offered</Link>
                </li>
                <li>
                  <Link to={"/otpri/admissions"}>Admissions</Link>
                </li>
                <li>
                  <Link to={"/otpri/fee-structure"}>Fee Structure (B.Pharmacy, M.Pharmacy)</Link>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">Library</Link>
                  <ul>
                    <li>
                      <Link to={"/otpri/library-policy"}>Library Policy</Link>
                    </li>
                    <li>
                      <Link to={"/otpri/digital-library"}>Digital Library</Link>
                    </li>
                  </ul>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">Departments</Link>
                  <ul>
                    <li>
                      <Link to={"/otpri/pharmacology"}>Pharmacology</Link>
                    </li>
                    <li>
                      <Link to={"/otpri/pharmaceutical-chemistry"}>Pharmaceutical Chemistry</Link>
                    </li>
                    <li>
                      <Link to={"/otpri/pharmaceutical-analysis"}>Pharmaceutical Analysis</Link>
                    </li>
                    <li>
                      <Link to={"/otpri/pharmaceutics"}>Pharmaceutics</Link>
                    </li>
                    <li>
                      <Link to={"/otpri/pharmacognosy"}>Pharmacognosy</Link>
                    </li>
                    <li>
                      <Link to={"/otpri/pharmd"}>Pharm.D</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to={"/otpri/admitted-details"}>Admitted Details</Link>
                </li>
              </ul>
            </li>

            <li className="hasSubmenu">
              <Link to="#">Examinations</Link>
              <ul>
                <li>
                  <Link to={"/category/Latest-News"}>University Examinations</Link>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">Internal Examinations</Link>
                  <ul>
                    {InternalExamination?.data?.attributes?.links?.map((group) =>
                      group.links?.map((link) => (
                        <li key={link.id}>
                          <a
                            href={
                              link.content?.data?.attributes?.url
                                ? imageBaseURL + link.content.data.attributes.url
                                : "#"
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            {link.label}
                          </a>
                        </li>
                      ))
                    )}
                  </ul>
                </li>
                <li>
                  <Link to={"/category/University-Examinations"}>Notifications & Circulars</Link>
                </li>
                <li>
                  <Link to="#">Malpractice Rules</Link>
                </li>
              </ul>
            </li>

            <li className="hasSubmenu">
              <Link to="#">Administration</Link>
              <ul>
                <li>
                  <Link to={"/profile/vice-chancellor"}>Vice Chancellor</Link>
                </li>
                <li>
                  <Link to={"/profile/rector"}>Rector</Link>
                </li>
                <li>
                  <Link to={"/profile/registrar"}>Registrar</Link>
                </li>
                <li>
                  <Link to={"/profile/director-of-oil-technological-pharmaceutical-research-institute"}>Director/Head</Link>
                </li>
                <li>
                  <Link to={"/profile/principal"}>Principal</Link>
                </li>
                <li>
                  <Link to={"/otpri/organizational-structure"}>Organizational Structure</Link>
                </li>
              </ul>
            </li>

            <li className="hasSubmenu">
              <Link to="#">Department</Link>
              <ul>
                <li>
                  <Link to={"/otpri"}>Pharmacy</Link>
                </li>
                <li>
                  <a
                    href={"https://app.gojntua.com/uploads/Faculty_Food_Technology_438a31d1c2.pdf"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Food Technology
                  </a>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Student Corner</Link>
               <ul>
                <li>
                  <a
                    href={
                      CareerGuidance?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + CareerGuidance.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                   Career Guidance/Placement Cell
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <Link to={"/otpri/grievance-redressal-cell"}>Grievance Redressal Cell</Link>
            </li>
            <li>
              <Link to={"/otpri/gallery"}>Gallery</Link>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Students & Committees</Link>
              <ul>
                <li>
                  <a
                    href={
                      STCell?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + STCell.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    SC, ST Committee
                  </a>
                </li>
                <li>
                  <a
                    href={
                      WomenEmpowermentCell?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + WomenEmpowermentCell.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    Women Empowerment Committee
                  </a>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">Committee</Link>
                  <ul>
                    {Committee?.data?.attributes?.links?.map((link) => (
                      <li key={link.id}>
                        <a
                          href={
                            link.content?.data?.attributes?.url
                              ? imageBaseURL + link.content.data.attributes.url
                              : "#"
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="hasSubmenu">
                  <Link to="#">Anti Ragging Cell</Link>
                  <ul>
                    {AntiRaggingCell?.data?.attributes?.links?.map((group) =>
                      group.links?.map((link) => (
                        <li key={link.id}>
                          <a
                            href={
                              link.content?.data?.attributes?.url
                                ? imageBaseURL + link.content.data.attributes.url
                                : "#"
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            {link.label}
                          </a>
                        </li>
                      ))
                    )}
                  </ul>
                </li>
                <li>
                  <Link to={"/otpri/anti-ragging-document"}>Anti Ragging Documents</Link>
                </li>
                <li>
                  <a
                    href={
                      GrievanceRedressedCommittee?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + GrievanceRedressedCommittee.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    Grievance Redressed Committee Cell
                  </a>
                </li>
                <li>
                  <a
                    href={
                      GenderSensitisation?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + GenderSensitisation.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    Gender Sensitisation
                  </a>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Food Technology</Link>
              <ul>
                <li>
                  <Link to={"/otpri/food-technology"}>About Department</Link>
                </li>
                <li>
                  <a
                    href={
                      FacultyFoodTechnology?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + FacultyFoodTechnology.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    Faculty Food Technology
                  </a>
                </li>
                 <li>
                  <a
                    href={
                      CoursesOfferedFT?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + CoursesOfferedFT.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                   Courses Offered
                  </a>
                </li>
                <li>
                  <a
                    href={
                      AdmissionDetailsFT?.data?.attributes?.section?.[0]?.link?.[0]?.content?.data?.attributes?.url
                        ? imageBaseURL + AdmissionDetailsFT.data.attributes.section[0].link[0].content.data.attributes.url
                        : "#"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                   Admission Details
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href={"https://www.google.com/maps/place/JNTUA+OTPRI/@14.6703829,77.6065055,17z/data=!3m1!4b1!4m14!1m7!3m6!1s0x3bb14b1e6ef41d75:0x7e1d8b0e9b31432d!2sJNTUA+OTPRI!8m2!3d14.6703777!4d77.6090804!16s%2Fg%2F1tfm52zt!3m5!1s0x3bb14b1e6ef41d75:0x7e1d8b0e9b31432d!8m2!3d14.6703777!4d77.6090804!16s%2Fg%2F1tfm52zt?authuser=0&entry=ttu&g_ep=EgoyMDI1MDExMC4wIKXMDSoASAFQAw%3D%3D"} target="_blank" rel="noreferrer">
                Institute location
              </a>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Online Resources</Link>
              <ul>
                <li>
                  <a href={"https://swayam.gov.in"} target="_blank" rel="noreferrer">
                    Swayam Central
                  </a>
                </li>
                <li>
                  <a href={"https://epgp.inflibnet.ac.in"} target="_blank" rel="noreferrer">
                    e-PGPathashala
                  </a>
                </li>
                <li>
                  <a href={"https://ndl.iitkgp.ac.in/"} target="_blank" rel="noreferrer">
                    National Digital Library of India
                  </a>
                </li>
                <li>
                  <a href={"https://shodhganga.inflibnet.ac.in/"} target="_blank" rel="noreferrer">
                    Shodhganga
                  </a>
                </li>
                <li>
                  <a href={"https://ess.inflibnet.ac.in/"} target="_blank" rel="noreferrer">
                    E-ShodhSindhu
                  </a>
                </li>
                <li>
                  <a href={"https://vidwan.inflibnet.ac.in/"} target="_blank" rel="noreferrer">
                    Vidwan | Profile Page - Inflibnet
                  </a>
                </li>
                <li>
                  <a href={"https://swayam-plus.swayam2.ac.in/"} target="_blank" rel="noreferrer">
                    Swayam Plus
                  </a>
                </li>
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to={"#"}>Students Achievement</Link>
              <ul>
                {StudentsAchievements?.data?.attributes?.section?.map((achievementSection) => (
                  <li key={achievementSection.id} className="hasSubmenu">
                    <Link to="#">{achievementSection.title}</Link>
                    <ul>
                      {achievementSection.links?.map((link) => (
                        <li key={link.id}>
                          <a
                            href={imageBaseURL + link.content?.data?.attributes?.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {link.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </li>
            <li className="hasSubmenu">
              <Link to="#">Programs Organized</Link>
              <ul className="programs-organized-menu">
                {ProgramsOrganized?.data?.attributes?.links?.map((link) => (
                  <li key={link.id}>
                    <a
                      href={
                        link.content?.data?.attributes?.url
                          ? imageBaseURL + link.content.data.attributes.url
                          : "#"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </li>

          </ul>
        )}
      </div>
    </div>
  );
};